import {PublicClientApplication} from '@azure/msal-browser'
import {LogLevel} from '@azure/msal-browser'

let msalInstance = null
let loginScopes

export const initializeMsal = async () => {
  console.log('cargando msal')
  // Cargar la configuración de forma asincrónica
  const response = await fetch('./config.json')
  const config = await response.json()

  loginScopes = {
    scopes: [config.REACT_APP_SCOPE_READ, config.REACT_APP_SCOPE_WRITE],
  }

  // Usar la configuración cargada para inicializar MSAL
  msalInstance = new PublicClientApplication({
    auth: {
      clientId: config.REACT_APP_CLIENT_ID_PORTAL,
      authority: config.REACT_APP_AUTHORITY,
      redirectUri: config.REACT_APP_REDIRECT_URI_PORTAL,
      knownAuthorities: [config.REACT_APP_KNOWN_AUTHORITIES],
    },
    cache: {
      cacheLocation: 'sessionStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message)
              return
            default:
              return
          }
        },
      },
    },
  })
  await msalInstance.initialize()
}

export const getLoginContext = () => {
  if (!loginScopes) {
    throw new Error('LoginScopes Instance is not initialized.')
  }
  return loginScopes
}

export const getMsalInstance = () => {
  if (!msalInstance) {
    throw new Error('MSAL Instance is not initialized.')
  }
  return msalInstance
}
